import { lazy, Suspense } from 'react';
import AppShell from './app/AppShell.jsx';
import { RouteError } from './app/ErrorBoundary.jsx';
import HomePage from './features/decks/HomePage.jsx';
import DeckPage from './features/decks/DeckPage.jsx';
import StudyPage from './features/study/StudyPage.jsx';
import NotFound from './app/NotFound.jsx';

const NoteEditorPage = lazy(() => import('./features/notes/NoteEditorPage.jsx'));
const BrowserPage = lazy(() => import('./features/browser/BrowserPage.jsx'));
const TrashPage = lazy(() => import('./features/trash/TrashPage.jsx'));
const BackupsPage = lazy(() => import('./features/backups/BackupsPage.jsx'));
const SettingsPage = lazy(() => import('./features/settings/SettingsPage.jsx'));
const AuthPage = lazy(() => import('./features/auth/AuthPage.jsx'));
const WelcomePage = lazy(() => import('./features/onboarding/WelcomePage.jsx'));
const GuidePage = lazy(() => import('./features/guide/GuidePage.jsx'));

const bare = (page) => (
  <Suspense fallback={null}>
    {page}
  </Suspense>
);

export const routes = [
  {
    path: '/auth',
    element: bare(<AuthPage />),
    errorElement: <RouteError />,
  },
  {
    path: '/welcome',
    element: (
      <Suspense fallback={null}>
        <WelcomePage />
      </Suspense>
    ),
    errorElement: <RouteError />,
  },
  {
    path: '/',
    element: <AppShell />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'deck/:deckId', element: <DeckPage /> },
      { path: 'study/:deckId', element: <StudyPage /> },
      { path: 'study', element: <StudyPage /> },
      { path: 'add', element: <NoteEditorPage /> },
      { path: 'note/:noteId', element: <NoteEditorPage /> },
      { path: 'browse', element: <BrowserPage /> },
      { path: 'trash', element: <TrashPage /> },
      { path: 'backups', element: <BackupsPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'guide', element: <GuidePage /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];
